// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7aa73605","453":"72c22ff0","455":"15e1b25a"}[chunkId] + ".chunk.js";
};